import { CarrierEnums } from '../../../../enums/carriers';
import { Providers } from '../../../../enums/providers';
import { todoCardIds } from '../../../../pages/home-page/version2/todo-cards/todo-card-ids';
import { CountryConfigNames } from '../../country-config-enums';
import { CountryUIFeature } from '../country-ui-feature';

export const GBCountryUIConfig = [
  new CountryUIFeature(CountryConfigNames.PreferredCarrier, {
    carrierId: CarrierEnums.RoyalMailClickAndDropWalleted.carrierId,
  }),
  new CountryUIFeature(CountryConfigNames.PreferredProvider, {
    labelProviderId: Providers.RoyalMailClickAndDropWalleted.labelProviderId,
  }),
  new CountryUIFeature(CountryConfigNames.PreferredWalletedProvidersIds, {
    labelProvidersIds: [Providers.RoyalMailClickAndDropWalleted.labelProviderId],
  }),
  new CountryUIFeature(CountryConfigNames.FTUWizardHiddenTodoCards, {
    todoCardIds: [todoCardIds.GET_STARTED_WEBINAR, todoCardIds.ACCOUNT_OPTIMIZATION_WEBINAR],
  }),
  new CountryUIFeature(CountryConfigNames.ShowsUpgradePlanPromotionalBanner),
  new CountryUIFeature(CountryConfigNames.RateBrowserDefaults, {
    length: 10,
    width: 10,
    height: 10,
  }),
  new CountryUIFeature(CountryConfigNames.ShowsDdpImportDutiesWarning),
];
